import { useEffect, useState } from "react";
import Container from "../../../Components/Cards/Information/container";

export default function Information({ payoutData, accLoading }) {
  const [totalProfit, setTotalProfit] = useState(0);
  useEffect(() => {
    if (payoutData) {
      let profit = 0;
      payoutData.accounts.forEach((item) => {
        if (item.can_payout) {
          profit += item.available_for_payout;
        }
      });
      setTotalProfit(profit);
    }
  }, [payoutData]);
  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
        اطلاعات برداشت
      </h3>

      <div className="w-full overflow-auto flex gap-10 justify-evenly items-center">
        <Container
          color="green"
          width="300px"
          className=""
          accLoading={accLoading}
          title="سود قابل برداشت"
          value={
            payoutData
              ? `$${Number(Number(totalProfit).toFixed(2)).toLocaleString()}`
              : ""
          }
          svgName="profitAvailable"
          svgClassName=""
        />
        <Container
          color="yellow"
          width="300px"
          className=""
          accLoading={accLoading}
          title="مبلغ در حال پردازش"
          value={
            payoutData
              ? `$${Number(
                  Number(payoutData.total_under_processing).toFixed(2)
                ).toLocaleString()}`
              : ""
          }
          svgName="profitProcess"
          svgClassName=""
        />
        <Container
          color="blue"
          width="300px"
          className=""
          accLoading={accLoading}
          title="مبلغ برداشت شده"
          value={
            payoutData
              ? `$${Number(
                  Number(payoutData.total_already_payed_out).toFixed(2)
                ).toLocaleString()}`
              : ""
          }
          svgName="profitDone"
          svgClassName=""
        />
      </div>
    </div>
  );
}
